import { JobStatus } from "namirasoft-job-arranger";

export class JobStatusObject
{
    static BlackList: JobStatusObject = new JobStatusObject(JobStatus.BlackList, "#00000080");
    static WhiteList: JobStatusObject = new JobStatusObject(JobStatus.WhiteList, "#00AAFF44");
    static Applied: JobStatusObject = new JobStatusObject(JobStatus.Applied, "#00AAFFCC");
    static Replied: JobStatusObject = new JobStatusObject(JobStatus.Replied, "#FFF99FFF");
    static Interviewed: JobStatusObject = new JobStatusObject(JobStatus.Interviewed, "#00ff0040");
    static Rejected: JobStatusObject = new JobStatusObject(JobStatus.Rejected, "#ff000080");
    static Hired: JobStatusObject = new JobStatusObject(JobStatus.Hired, "#008000A0");
    name: JobStatus;
    color: string;
    constructor(name: JobStatus, color: string)
    {
        this.name = name;
        this.color = color;
    }
    static get(name: string | null): JobStatusObject | null
    {
        if (name)
        {
            let all = this.getAll();
            for (let status of all)
            {
                if (status.name === name)
                    return status;
            }
        }
        return null;
    }
    static getAll(): JobStatusObject[] 
    {
        let ans: JobStatusObject[] = [JobStatusObject.BlackList, JobStatusObject.WhiteList, JobStatusObject.Applied, JobStatusObject.Replied, JobStatusObject.Interviewed, JobStatusObject.Rejected, JobStatusObject.Hired];
        return ans;
    }
}